import { api, ApiRes } from './client'

export interface BasketRequest {
    asset_var_uid: string | null
    natural_profile_uid?: string | null
    legal_profile_uid?: string | null
    stage: string | null
    profile_type: 'natural' | 'legal'
}

export interface BasketResponse {
    id: string | null
    stage: string | null
}

export const postBasket = (basket: BasketRequest): ApiRes<BasketResponse> => api.post('baskets', basket)
